import { render, staticRenderFns } from "./payments-tab.vue?vue&type=template&id=0f9588e5&scoped=true"
import script from "./payments-tab.vue?vue&type=script&lang=js"
export * from "./payments-tab.vue?vue&type=script&lang=js"
import style0 from "./payments-tab.vue?vue&type=style&index=0&id=0f9588e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9588e5",
  null
  
)

export default component.exports